import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBrandDotAiComponent } from './simple-icons-brand-dot-ai.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBrandDotAiComponent ],
    exports:      [ SimpleIconsBrandDotAiComponent ],
    bootstrap:    []
})
export class SimpleIconsBrandDotAiModule {}
